module.exports = __webpack_public_path__ + "static/img/data-management-300x300.3e7b5ca3.jpg";